import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { loadRepo } from './data/mode';
import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/newsreader/wght.css';
import './styles.css';

const root = createRoot(document.getElementById('root')!);

// Decide demo vs live before any data code runs. Demo never loads the Supabase client.
loadRepo({ url: import.meta.env.VITE_SUPABASE_URL, publishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY }).then((state) => {
  if (state.kind === 'unconfigured') {
    root.render(
      <main className="gate">
        <div className="panel gate-card">
          <h1>Finance <span>Cockpit</span></h1>
          <p className="muted">This build has no database configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY, or open <a href="?demo=1">Demo Mode</a>.</p>
        </div>
      </main>,
    );
    return;
  }
  root.render(<StrictMode><App repo={state.repo} /></StrictMode>);
});

// Service worker: enables install as an app. It never caches data, and a new
// build takes over on the next open, so a stale build cannot linger.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').then((reg) => reg.update());
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
